import { debounce } from '@/utils/api';
import { onMounted, onBeforeUnmount } from 'vue';

export const DEVICE_RESIZE_DELAY = 50;

export function useDeviceResize(callback, delay = DEVICE_RESIZE_DELAY) {
	const onResize = debounce(() => {
		callback && callback();
	}, delay);

	onMounted(() => {
		window.addEventListener('resize', onResize);
	});
	onBeforeUnmount(() => {
		window.removeEventListener('resize', onResize);
	});

	return {
		onResize
	};
}
